import { Link } from 'react-router-dom';

import { Tooltip } from '@mui/joy';

import useIsTruncated from '@/shared/hooks/useIsTruncated';

type BuildingUnitWithCoOwner = {
  buildingUnitId: string;
  coOwner: string | null;
  contactId: string | null;
  companyId: string | null;
};

type Props = {
  rowData: {
    buildingUnits: BuildingUnitWithCoOwner[];
  };
};

const AccessKeyCoOwnerNameCell: React.FC<Props> = ({ rowData }) => {
  const { ref: containerRef, isTruncated } = useIsTruncated<HTMLDivElement>();
  const unitsWithCoOwner = rowData.buildingUnits.filter((unit) => unit.coOwner);
  const label = unitsWithCoOwner.map((unit) => unit.coOwner).join(', ');

  if (!unitsWithCoOwner.length) return '-';

  return (
    <Tooltip title={isTruncated ? label : ''} placement="top-start">
      <div ref={containerRef} className="truncate">
        {unitsWithCoOwner.map((unit, index) => (
          <span key={unit.buildingUnitId}>
            {index > 0 ? ', ' : null}
            <Link
              to={unit.contactId ? `/contact/${unit.contactId}` : `/company/${unit.companyId}`}
              target="_blank"
            >
              {unit.coOwner}
            </Link>
          </span>
        ))}
      </div>
    </Tooltip>
  );
};

export default AccessKeyCoOwnerNameCell;
